import { Icon } from './Icon'
import type { IconProps } from './Icon'
export const GifIcon = (p: IconProps) => (
  <Icon {...p}>
    <rect x="3" y="5" width="18" height="14" rx="2" />
    <path d="M8 10v4M8 12h1.5" />
    <path d="M12 10v4h2" />
    <path d="M17.5 10h-2v4h2v-2h-1" />
  </Icon>
)
